import View from './View';

export default class ZViewWrap extends View {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }
}
